
(function () {
    'use strict';

    angular.module(modules.homeModule)
        .controller('reportsMyReadingListViewController', reportsMyReadingListViewController);

    reportsMyReadingListViewController.$inject = ['$state', '$stateParams', '$http'];

    function reportsMyReadingListViewController($state, $stateParams, $http) {
        var vm = this; 

        initialize();

        function initialize() {
            
            var screenHeight = window.innerHeight;
            angular.element('#frameReport').height(screenHeight - 50);

            vm.reportPage = `/Reports/Viewer.aspx?reportType=11&userId=${user.userId}`;
        };

        $(window).on('resize', function () {
            var screenHeight = window.innerHeight;
            angular.element('#frameReport').height(screenHeight - 50);
        });
    };

})();